import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import CardJobs from './CardJobs';
import { publicEndpoints } from '../../utils/commonVariables/endpoints';
import { CircularProgress } from '@mui/material';
import '../../stylesheets/jobsMuggle.scss';

export default function Jobs() {
    const [jobs, setJob] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleJobs = async () => {
        setIsLoading(true);
        const endpoint = publicEndpoints.getJobOffers;
        const res = await api.get(endpoint);
        setJob(res.data.Result);
        setIsLoading(false);
    };

    useEffect(() => {
        handleJobs();
    }, []);

    return (
        <div className='faq jobs__container'>
            <div className='join-us-container margin-auto'>
                <h1 className='text-align-center section-title-muggle-long'>
                    Join a new and challenging team now!
                </h1>
            </div>

            <div className='introduction margin-auto'>
                <h3 className='text-align-center'>Become a disruptor!</h3>
                <p className='text-align-justify margin-top-16'>
                    Join our team and be a part of tomorrow&apos;s hotel
                    distribution model. We are a young company, fast moving and
                    highly motivated to create the next generation hotel
                    distribution business. We love what we do, we aim to be
                    different and thrive to create new technologies to solve
                    complex problems.
                </p>
                <p className='text-align-center margin-block-8'>
                    Contact us at:
                </p>
                <p className='text-align-center font-weight-b'>
                    hr@fastpayhotels.com
                </p>
            </div>

            <div className='container-jobs'>
                {isLoading ? (
                    <div className='flex-center-center padding-block-8'>
                        <CircularProgress size={24} />
                    </div>
                ) : (
                    <ul className='list-none'>
                        {jobs.map(job => (
                            <li
                                className='jobs-item padding-block-8'
                                key={job.Id}
                            >
                                <CardJobs job={job} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
